import ControlComponent from './components/Control';
import FooterComponent from './components/Footer';

function App() {
  return (
    <div>
      <ControlComponent />
      <FooterComponent />
    </div>
  );
}

export default App;
